"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OverflowGroup;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _StyledOverflowGroup = require("./StyledOverflowGroup");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbUtils = require("ykb-utils");
var _Resizer = require("./Resizer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function OverflowGroup(props) {
  var _useState = (0, _react.useState)(_Resizer.width.window()),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    observedWidth = _useState2[0],
    setObservedWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isVisible = _useState4[0],
    setIsVisible = _useState4[1];
  (0, _react.useLayoutEffect)(function () {
    var observeElement = props.observeElement;
    var container = (0, _ykbUtils.containerChecker)();
    function updateSize() {
      var elementWidth = _Resizer.width[observeElement]({
        container: container
      }) || _Resizer.width.window();
      setObservedWidth(elementWidth);
    }
    var observerProps = {
      container: container,
      updateSize: updateSize
    };
    var element = _Resizer.observer[observeElement](observerProps) || _Resizer.observer.window({
      container: container
    });
    element.observe();
    return function () {
      return element.unobserve();
    };
  }, []);
  function getOverlay() {
    if (Array.isArray(props.children)) {
      return /*#__PURE__*/_react.default.createElement(_StyledOverflowGroup.OverflowGroupMenu, null, _react.Children.map(props.children, function (child, index) {
        var _clonedElement = /*#__PURE__*/(0, _react.cloneElement)(child, {
          type: 'link',
          className: 'fluid'
        });
        return /*#__PURE__*/_react.default.createElement(_StyledOverflowGroup.OverflowGroupMenuItem, {
          key: "OverflowGroup-".concat(index)
        }, _clonedElement);
      }));
    }
  }
  if (props.breakpoint && observedWidth > props.breakpoint) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.children);
  }
  function handleVisibleChange(visible) {
    setIsVisible(visible);
  }
  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    prefixCls: "OverflowGroup-Dropdown",
    overlay: getOverlay(),
    onVisibleChange: handleVisibleChange,
    trigger: ['click']
  }, /*#__PURE__*/_react.default.createElement(_StyledOverflowGroup.OverflowGroupButton, {
    type: "secondary",
    $align: props.align,
    size: props.size,
    suffix: /*#__PURE__*/_react.default.createElement(_StyledOverflowGroup.StyledIcon, {
      className: isVisible ? 'rotate' : '',
      name: "angle-down",
      size: "medium",
      colorType: "primary"
    })
  }, props.text || 'Diğer Aksiyonlar'));
}
OverflowGroup.propTypes = {
  text: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  onClick: _propTypes.default.func,
  breakpoint: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]),
  observeElement: _propTypes.default.oneOf(['window', 'container']),
  align: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large'])
};
OverflowGroup.defaultProps = {
  text: 'Diğer Aksiyonlar',
  breakpoint: 1199,
  observeElement: 'window',
  align: 'left',
  size: 'medium'
};